import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, role, allowIncomplete = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div className="text-center py-5">Laddar...</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;

  if (!allowIncomplete && user.mustCompleteProfile && location.pathname !== "/profile") {
    return <Navigate to="/profile" replace />;
  }
  if (role && user.role !== role) return <Navigate to="/" replace />;

  return children;
}
